import {Formik} from "formik";
import {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {Col, Form, Modal, Row} from "react-bootstrap";
import {IConfigTable} from "../../models/OctResponse";
import {CODE_SUCCESS, ERROR_MESSAGE} from "../../utils/Constant";
import CorrectiveSubsectionTable from "../components/CorrectiveSubsectionTable";
import {
  RESULT,
} from "../constants/CorrectiveSubsectionModal";
import EvaluateDetailsModal from "./EvaluateDetailsModal";
import {
  getCriteriaByPlan,
} from "../services/CorrectiveSubsectionServices";
import {toast} from "react-toastify";
import {AppContext} from "../../appContext/AppContext";
import {generateForm} from "../../utils/AppFunction";
import ModalHeader from "../../component/ModalHeader";
import {useCSContext} from "../contexts";
import TextField from "../../component/TextField";

type Props = {
  show: boolean;
  handleCloseDialog: () => void;
  type: string
  itemDetail: any;
  setItemDetail: Dispatch<SetStateAction<any>>;
};

const CorrectiveSubsectionModal = (props: Props) => {
  const {setIsLoading} = useContext(AppContext);
  const {isView} = useCSContext();
  const {show, handleCloseDialog, type, itemDetail, setItemDetail} = props;
  const [objectSearch, setObjectSearch] = useState<any>();
  const [configTable, setConfigTable] = useState<IConfigTable>({
    totalPages: 1,
    totalElements: 5,
    numberOfElements: 5,
  });
  const [dataTable, setDataTable] = useState<any>();
  const [dataTableDetailRow, setDataTableDetailRow] = useState<any>();
  const [showEvaluateDetailsModal, setShowEvaluateDetailsModal] = useState(false);
  const [tableCache, setTableCache] = useState<{ [key: string]: any[] }>({});
  const [reload, setReload] = useState(false);
  const [formJson, setFormJson] = useState<any>([]);

  useEffect(() => {
    updateForm().then(r => r);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateForm = async () => {
    if (type) {
      const data = await generateForm(type, setIsLoading);
      setFormJson(data || []);
    }
  };

  const handleSubmit = (values: any) => {
    const newValues = {
      planId: itemDetail?.planId,
      itemDetailId: itemDetail?.itemDetailId,
      planCriteriaId: itemDetail?.id,
      level: values?.level?.id,
    };
    setObjectSearch(newValues);
  }

  useEffect(() => {
    if (itemDetail) {
      setDataTable(itemDetail.actions || []);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemDetail?.id]);

  useEffect(() => {
    if (itemDetail) {
      setObjectSearch((prev: any) => ({
        ...prev,
        planId: itemDetail?.planId,
      }));
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetSubSessionByPlanCriteria = async (
    forceReload: boolean = false
  ): Promise<void> => {
    const key = objectSearch?.level;
    const cachedData = tableCache[key];

    if (!forceReload && cachedData) {
      setDataTable(cachedData);
      return;
    }

    if (!itemDetail?.id) return;

    try {
      setIsLoading(true);
      const {data} = await getCriteriaByPlan(itemDetail?.planCriteriaId);
      if (data?.code === CODE_SUCCESS) {
        const newData = data?.data?.map((item: any) => ({
          ...item,
          pointSelfAssessment:
            RESULT.find(
              (result: any) => result.id === item?.pointSelfAssessment
            ) || null,
          conclusionAssessment:
            RESULT.find(
              (result: any) => result.id === item?.conclusionAssessment
            ) || null,
          evidence: {
            id: item?.fileId,
            name: item?.fileName,
          },
        }));

        setDataTable(newData);

        setConfigTable({
          totalPages: data.data.totalPages,
          totalElements: data.data.totalElements,
          numberOfElements: data.data.numberOfElements,
        });

        setTableCache((prev) => ({
          ...prev,
          [key]: newData,
        }));
      }
    } catch (error) {
      console.error("error", error);
      toast.error(ERROR_MESSAGE);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (objectSearch?.level) {
      handleGetSubSessionByPlanCriteria(false).then(r => r);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectSearch]);

  useEffect(() => {
    if (objectSearch?.level) {
      handleGetSubSessionByPlanCriteria(true).then(r => r);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return (
    <Modal
      className="page-full"
      fullscreen
      dialogClassName="h-modal"
      size="xl"
      show={show}
      animation={false}
      centered
      backdropClassName="spaces top-50"
    >
      <ModalHeader onHide={handleCloseDialog} title="Danh sách tiểu mục khắc phục"/>
      <Modal.Body className="px-0 py-0 spaces overflow-hidden h-calc-vh-90 bg-white">
        <Formik
          enableReinitialize
          initialValues={{[type]: {...itemDetail}}}
          onSubmit={handleSubmit}
        >
          {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
            <Form onSubmit={handleSubmit} className="h-auto">
              <div className="spaces px-10">
                <Form>
                  <Row className="my-3">
                    <Col xs={6}>
                      <TextField
                        label="Kế hoạch cần khắc phục"
                        value={itemDetail?.planName || ""}
                        name="planName"
                        disabled
                      />
                    </Col>
                    <Col xs={6}>
                      <TextField
                        label="Tiêu chí cần khắc phục"
                        value={itemDetail?.criteriaName || ""}
                        name="criteriaName"
                        disabled
                      />
                    </Col>
                  </Row>
                </Form>
              </div>
              {showEvaluateDetailsModal && (
                <EvaluateDetailsModal
                  show={showEvaluateDetailsModal}
                  handleCloseDialog={() => setShowEvaluateDetailsModal(false)}
                  dataTableDetailRow={dataTableDetailRow}
                />
              )}
            </Form>
          )}
        </Formik>
        <CorrectiveSubsectionTable
          dataTable={dataTable}
          setDataTable={setDataTable}
          objectSearch={objectSearch}
          setObjectSearch={setObjectSearch}
          configTable={configTable}
          setConfigTable={setConfigTable}
          type={type}
          tableCache={tableCache}
          setTableCache={setTableCache}
          reload={reload}
          setReload={setReload}
        />
      </Modal.Body>
    </Modal>
  );
};

export default CorrectiveSubsectionModal;
